import { render } from "./MobDiscover.vue?vue&type=template&id=79b2e23b&scoped=true"
import script from "./MobDiscover.vue?vue&type=script&lang=js"
export * from "./MobDiscover.vue?vue&type=script&lang=js"

import "./MobDiscover.vue?vue&type=style&index=0&id=79b2e23b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b2e23b"]])

export default __exports__